import {Component} from '@angular/core';
import {BreadCrumbElement} from "../../../shared/entities/breadcrumb.element.entity";
import {ActivatedRoute} from "@angular/router";
import {EventsService} from "../../../services/events/events.service";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {LoadingIndicatorService} from "../../../services/loading-indicator/loading-indicator.service";
import {HousingInfoService} from "../../../services/housing-info/housing-info.service";

@Component({
  selector: 'app-housing-info',
  templateUrl: './housing-info.component.html',
  styleUrls: ['./housing-info.component.css']
})
export class HousingInfoComponent {
  /* */
  public breadCrumbElements: Array<BreadCrumbElement> = [];

  /* */
  public backgroundImage = '/assets/media/photos/photo21@2x.jpg';
  public containerBackgroundImage = {'background-image': 'url(' + this.backgroundImage + ')'};
  public subContainerBackgroundImage = {};
  public containerClass = {'bg-image': true};
  public subContainerClass = {'bg-white-op-90': true};
  public contentClass: any = {'content': true, 'text-center': true, 'content-top': true};
  public pyClass = {'py-50': true};
  public h1class: any = {'h1': true};
  public h2class: any = {'h4': true};

  /* */
  public housingId: string;

  /* */
  public housing;

  /* */
  constructor(private activatedRoute: ActivatedRoute,
              public housingInfoService: HousingInfoService,
              private eventsService: EventsService,
              private loadingIndicatorService: LoadingIndicatorService,
              private http: HttpClient) {


    this.eventsService.on("housingInfoReloadHousingData", () => {
      this.requestData();
    });

    this.housingId = this.activatedRoute.snapshot.params['housingId'];
    this.requestData();
  }

  public requestData() {
    this.loadingIndicatorService.showLoadingBar();

    this.http.get(environment.urls.service + '/api/v1/authenticated/admin/housing/' + this.housingId)
      .subscribe((response: any) => {
          this.loadingIndicatorService.hideLoadingBar();
          this.housingInfoService.setSelectedHousing(response);
          this.housing = this.housingInfoService.getSelectedHousing();
          // this.eventsService.broadcast("housingInfoReloadHousing")
          this.updateBreadcrumb();
        },
        err => {
          this.loadingIndicatorService.hideLoadingBar();
        });
  }

  updateBreadcrumb() {
    this.breadCrumbElements = [
      new BreadCrumbElement('tripmakery', 'javascript:void(0)'),
      new BreadCrumbElement('Housings', 'javascript:void(0)'),
      new BreadCrumbElement(this.housingInfoService.getSelectedHousing().name, 'javascript:void(0)')
    ];
  }

}
